module.exports = __webpack_public_path__ + "img/icon-close.e1dd3f26.svg";